import { UseFormSetError } from 'react-hook-form';
import { ResponseError } from './types';

interface ResponseErrorsResolverProps {
  errors: ResponseError;
  setError: UseFormSetError<any>;
  setGlobalError?: (data: string) => void;
  setOtherErrors?: (data: string[]) => void;
}

export default function responseErrorsResolver({
  errors,
  setError,
  setGlobalError,
  setOtherErrors,
}: ResponseErrorsResolverProps) {
  if (errors.data?.message) {
    if (Array.isArray(errors.data.message)) {
      if (errors.data.message?.length === 1) {
        if (errors.data.message[0]?.property) {
          if (
            errors.data.message[0]?.property === 'coreError' &&
            setGlobalError
          ) {
            setGlobalError(errors?.data?.message[0]?.value as string);
          } else {
            errors.data.message.forEach((item) => {
              let errorString = '';

              if (item.constraints && Object.values(item.constraints)[0]) {
                if (
                  Object.values(item.constraints)[0].includes(item.property)
                ) {
                  errorString = Object.values(item.constraints)[0].replace(
                    item.property,
                    item.property
                      .split(/(?=[A-Z])/)
                      ?.map(
                        (string) =>
                          `${string.charAt(0).toUpperCase()}${string.slice(1)}`,
                      )
                      .join(' '),
                  );
                } else {
                  const [errorText] = Object.values(item.constraints);

                  errorString = errorText;
                }
              } else if (
                !item.constraints &&
                item.children?.length &&
                setOtherErrors
              ) {
                const childrenMessages: string[] = [];

                item.children.forEach((childrenMessage) => {
                  childrenMessage?.children?.forEach((message: any) => {
                    if (
                      message.constraints &&
                      Object.values(message.constraints)[0]
                    ) {
                      childrenMessages.push(
                        `${
                          // @ts-ignore
                          Object.values(message.constraints)[0].replace(
                            message.property,
                            message.property
                              .split(/(?=[A-Z])/)
                              ?.map(
                                (string: string) =>
                                  `${string
                                    .charAt(0)
                                    .toUpperCase()}${string.slice(1)}`,
                              )
                              .join(' '),
                          )
                        } (${message?.value})`,
                      );
                    }
                  });
                });

                if (childrenMessages?.length) {
                  setOtherErrors(childrenMessages);
                }
              }

              if (errorString) {
                setError(item.property, {
                  type: 'custom',
                  message: errorString,
                });
              }
            });
          }
        } else if (
          !errors.data.message[0]?.property &&
          typeof errors.data.message[0] === 'string' &&
          setGlobalError
        ) {
          setGlobalError(errors.data.message?.map((item) => item)?.join(', '));
        }
      } else if (errors.data.message?.length > 1) {
        const coreErrorsArray: string[] = [];

        errors.data.message?.forEach((item) => {
          if (item.property && item.property === 'coreError') {
            coreErrorsArray.push(item.value as string);
          } else if (!item.property && typeof item === 'string') {
            coreErrorsArray.push(item);
          }
        });

        const otherErrors = errors.data.message?.filter(
          (item) => item.property && item.property !== 'coreError',
        );

        if (coreErrorsArray?.length && setGlobalError) {
          const errorsString = coreErrorsArray?.map((item) => item)?.join(', ');

          setGlobalError(errorsString);
        }

        if (otherErrors?.length) {
          otherErrors.forEach((item) => {
            let errorString = '';

            if (item.constraints && Object.values(item.constraints)[0]) {
              if (Object.values(item.constraints)[0].includes(item.property)) {
                errorString = Object.values(item.constraints)[0].replace(
                  item.property,
                  item.property
                    .split(/(?=[A-Z])/)
                    ?.map(
                      (string) =>
                        `${string.charAt(0).toUpperCase()}${string.slice(1)}`,
                    )
                    .join(' '),
                );
              } else {
                const [errorText] = Object.values(item.constraints);
                
                errorString = errorText;
              }
            }

            setError(item.property, {
              type: 'custom',
              message: errorString,
            });
          });
        }
      }
    } else if (typeof errors?.data?.message === 'string' && setGlobalError) {
      setGlobalError(errors?.data?.message);
    } else {
      // eslint-disable-next-line no-lonely-if
      if (setGlobalError) {
        setGlobalError('Internal Server Error. Try Again');
      }
    }
  }
}
